interface LinkProps {
  children?: string | string[] | React.Component | React.Component[];
  className?: string;
  id?: string;
  onClick?: (event: React.MouseEvent) => void;
  title?: string;
  to?: string;
}

export default class Link extends React.PureComponent<LinkProps> {
  static defaultProps = {
    className: '',
    title: null,
  };

  onClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const { to } = this.props;
    if (event.ctrlKey) {
      window.open(`${window.location.pathname}#${to}`);
      return;
    }

    if (!to) {
      console.warn('no to props set on router Link');
      return;
    }

    window.location.hash = to;
  };

  render() {
    const { to, children, title, className, onClick, id } = this.props;

    return (
      <a
        id={id}
        href={`${window.location.pathname}#${to}`}
        className={`Edocat-Router-Link ${className}`}
        onClick={onClick ? onClick : this.onClick}
        title={title}
      >
        {children}
      </a>
    );
  }
}
